// src/components/NotFound.js
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <h1 className="text-4xl font-bold mb-4">404 - Page Not Found</h1>
      <p className="mb-8">
        Sorry, the page you are looking for does not exist.
      </p>
      <button
        onClick={() => navigate("/projects-list")}
        className="px-4 py-2 bg-blue-500 text-white rounded"
      >
        Back to Projects
      </button>
    </div>
  );
};

export default NotFound;
